import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { ApiService } from "../api/api.service";
import { BehaviorSubject, Observable } from "rxjs";
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import {
  pageInfo,
  Constant,
  PlatFormType,
  PlatFormNames,
} from "src/app/common/constant/constant";
import { map } from "rxjs/operators";
import { User } from "../../components/_models/user";
import { Router } from "@angular/router";
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NoPermissionPopupComponent } from '../../components/common/no-permission-popup/no-permission-popup.component';
import { ViewKaDetailComponent } from '../../components/common/view-ka-detail/view-ka-detail.component';
import { ViewDocumentDetailComponent } from 'src/app/components/common/view-document-detail/view-document-detail.component';
import { FixesSubscriptionExpiredComponent } from 'src/app/components/common/fixes-subscription-expired/fixes-subscription-expired.component';
import { environment } from 'src/environments/environment';
import { settings } from "cluster";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService {
  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;
  public apiKey: string = Constant.ApiKey;
  public checkAccessVal : boolean = false;
  public checkAccessItems: any = [];
  public bodyElem;
  public userId;
  public domainId;
  public accessRoportPage: boolean = false;
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private http: HttpClient,
    private apiUrl: ApiService,
    private dashboardService: DashboardService,
    private modalService: NgbModal,
  ) {
    this.userSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("user"))
    );
    this.user = this.userSubject.asObservable();

    let user = JSON.parse(localStorage.getItem("user"));
      if(user && this.apiUrl.enableAccessLevel) {
        let domainId = user?.domain_id;
        let userId = user?.Userid;
        this.userId=userId;
        this.domainId=domainId;
        let roleId = user?.roleId;
        let apiData = {
          'apiKey': this.apiKey,
          'userId': userId,
          'domainId': domainId,
          'roleId': roleId,
          'adminPage' : 0
        };
        this.dashboardService.getRolesAndPermissions(apiData).subscribe(roles => {
          localStorage.setItem('param',JSON.stringify(roles));
        })
      }
  }

  public get userValue(): User {
    return this.userSubject.value;
  }

  //register email id / user name and password
  //register profile details
  signup(signupData) {
    return this.http.post<any>(this.apiUrl.apiSignup(), signupData);
  }
  customerSignup(signupData) {
    return this.http.post<any>(this.apiUrl.apiCustomerSignup(), signupData);
  }
  // validate username or email
  // validate password
  // login
  login(loginData) {
    localStorage.removeItem("loggedOut");
    return this.http.post<any>(this.apiUrl.apiLogin(), loginData);
  }

  fixesssologin(loginData) {
    localStorage.removeItem("loggedOut");
    return this.http.post<any>(this.apiUrl.apiLoginCbtFixsso(), loginData);
  }

  checkAccountInfo(loginData) {

    return this.http.post<any>(this.apiUrl.apicheckAccountInfo(), loginData);
  }

  //register / login success data
  UserSuccessData(user) {
    // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("networkId", user.networkId);
    //console.log(JSON.stringify(user));
    this.userSubject.next(user);
    return user;
  }

  ChatUCodeNew(theString) {
    var unicodeString = '';
    for (let i = 0; i < theString.length; i++) {
      var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
      while (theUnicode.length < 4) {
        theUnicode = '0' + theUnicode;
      }
      theUnicode = '\\u' + theUnicode;
      unicodeString += theUnicode;
    }
    return unicodeString;
  }

  ChatUCode(t) {
    var S = '';
    for (let a = 0; a < t.length; a++) {
      if (t.charCodeAt(a) > 255) {
        S += '\\u' + ('0000' + t.charCodeAt(a).toString(16)).substr(-4, 4).toUpperCase();
      } else {
        S += t.charAt(a);
      }
    }
    return S;
    //console.log(S);
  }

  ChatUCode1(t) {
    var S = "";
    for (let a = 0; a < t.length; a++) {
      if (t.charCodeAt(a) > 255) {
        S +=
          "\\u" +
          ("0000" + t.charCodeAt(a).toString(16)).substr(-4, 4).toUpperCase();
      } else {
        S += t.charAt(a);
      }
    }
    //console.log(S);
    return S;
  }

  convertunicode(val) {
    val = val.replace(/\\n/g, '')
      //.replace(/'/g, '"')
      .replace(/\\'/g, "\\'")
      .replace(/\\"/g, '\\"')
      .replace(/\\&/g, "\\&")
      .replace(/\\r/g, "\\r")
      .replace(/\\t/g, "\\t")
      .replace(/\\b/g, "\\b")
      .replace(/\\f/g, "\\f")
      .replace(/\\u2018/g, "‘")
      .replace(/\\u2019/g, "’")
      .replace(/\\u201C/g, '“')
      .replace(/\\u201D/g, '”');

      // remove non-printable and other non-valid JSON chars
      val = val.replace(/[\u0000-\u0019]+/g,"");

    if (val == undefined || val == null) {
      return val;
    }
    //val = "hirisjh \uD83D\uDE06 dfg dfg dd df g";
    if (val.indexOf("\\uD") != -1 || val.indexOf("\\u") != -1) {

      JSON.stringify(val)
      //console.log(JSON.parse('"\\uD83D\\uDE05\\uD83D\\uDE04"'));

      //console.log(JSON.parse("'" +"\\uD83D\\uDE05\\uD83D\\uDE04"+"'"));
      //return (JSON.parse('"' + val.replace(/\"/g, '\\"' + '"') + '"'));\
      if (this.IsJsonString(val)) {
        return (JSON.parse('"' + val.toString().replace(/\\"/g, '"').replace(/"/g, '\\"') + '"'));
      }
      else
      {
        let platformId = localStorage.getItem("platformId");
        if(platformId=='3' || platformId=='1')
        {
          //return val;
          //return (JSON.parse('"' + val.toString().replace(/\\"/g, '"').replace(/"/g, '\\"') + '"'));
          try {
            return (JSON.parse('"' + val.toString().replace(/\\"/g, '"').replace(/"/g, '\\"') + '"'));
          }
          catch(err) {
            return val;
          }
        }
        else
        {
          return (JSON.parse('"' + val.toString().replace(/\\"/g, '"').replace(/"/g, '\\"') + '"'));
        }

      }

  //return val;
  }

    else {
      return val;
    }

  }

  convertunicode1(val) {
    val = val.replace(/\\n/g, '')

      .replace("\\u2013", "")
      .replace(/'/g, '"')
      .replace(/\\'/g, "\\'")
      .replace(/\\"/g, '\\"')
      .replace(/\\&/g, "\\&")
      .replace(/\\r/g, "\\r")
      .replace(/\\t/g, "\\t")
      .replace(/\\b/g, "\\b")
      .replace(/\\f/g, "\\f");

    if (val == undefined || val == null) {
      return val;
    }

    //val = "hirisjh \uD83D\uDE06 dfg dfg dd df g";
    if (val.indexOf("\\uD") != -1 || val.indexOf("\\u") != -1) {
      //  JSON.stringify(val)
      if (this.IsJsonString(val)) {
        return JSON.parse('"' + val.replace(/\"/g, '\\"' + '"') + '"');
      } else {
        return val;
      }
      //console.log(JSON.parse('"\\uD83D\\uDE05\\uD83D\\uDE04"'));

      //console.log(JSON.parse("'" +"\\uD83D\\uDE05\\uD83D\\uDE04"+"'"));
    } else {
      return val;
    }
  }

  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  urladdTarget(text) {
   // return text;
    if (/href/.test(text)) {
      return text.toString().replace(/<a/gi, '<a target="_blank"');
    }
    else
    {
      return text;
    }


    //return text.replace('<a ','<a ');
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  }

 URLReplacer(str){

    let userAgent = navigator.userAgent;
    let browserName;
    if(userAgent.match(/chrome|chromium|crios/i)){
      browserName = "chrome";
    }else if(userAgent.match(/firefox|fxios/i)){
      browserName = "firefox";
    }  else if(userAgent.match(/safari/i)){
      browserName = "safari";
    }else if(userAgent.match(/opr\//i)){
      browserName = "opera";
    } else if(userAgent.match(/edg/i)){
      browserName = "edge";
    }else{
      browserName="No browser detection";
    }

    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    if (/img/.test(str)) {

      str =this.urladdTarget(str);
      return str;
    }
    if (/youtube/.test(str)) {

      str =this.urladdTarget(str);
      return str;
    }

    if (/href/.test(str)) {

      str =this.urladdTarget(str);
      return str;
    }

    let match = str.match(/(?!href=")(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);

    let match2 = str.match(/(?!href=")(^|[^\/])(www\.[\S]+(\b|$))/ig);
    let final=str;
    if(match)
    {
      match.map(url=>{
        final=final.replace(url,"<a href=\""+url+"\" target=\"_BLANK\">"+url+"</a>")
      });
      replacePattern2 = /(?!href=")(^|[^\/])(www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      //content.replace(/<[^>]*>/g, '');
      final = final.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

     // replacePattern3 = /(?href=")([\S]+(\b|$))(^.com)/ig;
      //content.replace(/<[^>]*>/g, '');
     // final = final.replace(replacePattern3, '<a href="http://$1" target="_blank">$1</a>');


      // replacePattern1 = /(?<!href=")(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      //final = final.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

     // replacePattern2 = /(?<!href=")(^|[^\/])(www\.[\S]+(\b|$))/gim;
      //final = final.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    }
    else
    {
      replacePattern2 = /(?!href=")(^|[^\/])(www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      //content.replace(/<[^>]*>/g, '');
      final = final.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    }
final =this.urladdTarget(final);
    return final;
  }
 /*
 // safari issue, updated below function
 URLReplacer1111(str) {
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    let platformId = localStorage.getItem("platformId");
    if (platformId == PlatFormType.CbaForum) {
      if (/href/.test(str)) {
        return str;
      }
      if (/img/.test(str)) {
        return str;
      }
    }

    let match = str.match(/(?<!href=")(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig);

    let match2 = str.match(/(?<!href=")(^|[^\/])(www\.[\S]+(\b|$))/ig);
    let final = str;
    if (match) {
      match.map(url => {
        console.log(url)
        final = final.replace(url, "<a href=\"" + url + "\" target=\"_BLANK\">" + url + "</a>")
      });
      replacePattern2 = /(?<!href=")(^|[^\/])(www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      //content.replace(/<[^>]*>/g, '');
      final = final.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

      // replacePattern3 = /(?:href=")([\S]+(\b|$))(^.com)/ig;
      //content.replace(/<[^>]*>/g, '');
      // final = final.replace(replacePattern3, '<a href="http://$1" target="_blank">$1</a>');


      // replacePattern1 = /(?:href=")(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      //final = final.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

      // replacePattern2 = /(?:href=")(^|[^\/])(www\.[\S]+(\b|$))/gim;
      //final = final.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    }
    else {
      replacePattern2 = /(?<!href=")(^|[^\/])(www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      //content.replace(/<[^>]*>/g, '');
      final = final.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    }

    return final;
  }
  */
  baseName(str){
    var base = new String(str).substring(str.lastIndexOf('/') + 1);
    /*if(base.lastIndexOf(".") != -1)
    base = base.substring(0, base.lastIndexOf("."));
    console.log(base);*/
    return base;
  } 

  fixesExpiredUpgradePOPUP(section='0'){

    this.bodyElem = document.getElementsByTagName('body')[0];
    if(document.body.classList.contains("subexp")) { }
    else{ this.bodyElem.classList.add("subexp"); }
    const modalRef1 = this.modalService.open(FixesSubscriptionExpiredComponent, {backdrop: 'static', keyboard: true, centered: true});
    let expiredSubscription = false;
    if(localStorage.getItem('isSubscriptionExpired') == 'true'){
      expiredSubscription = true;
    }
    modalRef1.componentInstance.expiredSubscription = expiredSubscription;
    //modalRef1.componentInstance.expiredSubscription = this.apiUrl.expiredSubscription;
    modalRef1.componentInstance.subscriptionInfo = this.apiUrl.subscriptionInfo;
    modalRef1.componentInstance.subscribedProduct = this.apiUrl.subscribedProduct;
    modalRef1.componentInstance.section = section;
    modalRef1.componentInstance.expServices.subscribe((receivedService) => {
      console.log(receivedService); 
      if(receivedService){
        this.router.navigateByUrl('account-subscription');
      }  
      modalRef1.dismiss('Cross click'); 
      this.bodyElem = document.getElementsByTagName('body')[0];
      this.bodyElem.classList.remove("subexp");   
    });
  }

  openPOPUPDetailView(typeId,id){
    switch(typeId){
      case 4:
        this.bodyElem = document.getElementsByTagName('body')[0];
        if(document.body.classList.contains("view-modal-popup")) { }
        else{ this.bodyElem.classList.add("view-modal-popup"); }
        const modalRef1 = this.modalService.open(ViewDocumentDetailComponent, {backdrop: 'static', keyboard: true, centered: true});
        modalRef1.componentInstance.dataId = id;
        modalRef1.componentInstance.documentServices.subscribe((receivedService) => {
          console.log(receivedService);
          modalRef1.dismiss('Cross click');
          setTimeout(() => {
            this.bodyElem = document.getElementsByTagName('body')[0];
            this.bodyElem.classList.remove("view-modal-popup");
            }, 100);
        });

        break;
      case 7:
        this.bodyElem = document.getElementsByTagName('body')[0];
        if(document.body.classList.contains("view-modal-popup")) { }
        else{ this.bodyElem.classList.add("view-modal-popup"); }
        const modalRef2 = this.modalService.open(ViewKaDetailComponent, {backdrop: 'static', keyboard: true, centered: true});
        modalRef2.componentInstance.knowledgeArticleId = id;
        modalRef2.componentInstance.KAServices.subscribe((receivedService) => {
          console.log(receivedService);
          modalRef2.dismiss('Cross click');
          setTimeout(() => {
            this.bodyElem = document.getElementsByTagName('body')[0];
            this.bodyElem.classList.remove("view-modal-popup");
            }, 100);
        });
        break;
    }


  }
  checkPwdStrongLength(password, maxLength) {
    let toLowerCaseCount = 0;
    let toUpperCaseCount = 0;
    let toSpecialCaseCount = 0
    let validateMsg = '';

    if (password.match(/[a-z]+/)) {
      toLowerCaseCount = 1;
    }
    if (password.match(/[A-Z]+/)) {
      toUpperCaseCount = 1;
    }
    if (password.match(/[#$%&!'()*+,-./:;<=>?@[\]^_`{|}~]+/)) {
      toSpecialCaseCount = 1;
    }

    if (password.length < maxLength) {
      validateMsg = 'Password must have min. ' + maxLength + ' chars.';
    }
    else {
      if (toLowerCaseCount == 0 && toUpperCaseCount == 1 && toSpecialCaseCount == 1) {
        validateMsg = 'Password must have one lowercase';
      }
      if (toLowerCaseCount == 1 && toUpperCaseCount == 0 && toSpecialCaseCount == 1) {
        validateMsg = 'Password must have one uppercase';
      }
      if (toLowerCaseCount == 1 && toUpperCaseCount == 1 && toSpecialCaseCount == 0) {
        validateMsg = 'Password must have one special character';
      }
      if (toLowerCaseCount == 0 && toUpperCaseCount == 0 && toSpecialCaseCount == 0) {
        validateMsg = 'Password must have one uppercase, one lowercase & one special character';
      }
      if (toLowerCaseCount == 0 && toUpperCaseCount == 0 && toSpecialCaseCount == 1) {
        validateMsg = 'Password must have one lowercase  & one uppercase';
      }
      if (toLowerCaseCount == 0 && toUpperCaseCount == 1 && toSpecialCaseCount == 0) {
        validateMsg = 'Password must have one lowercase & one special character';
      }
      if (toLowerCaseCount == 1 && toUpperCaseCount == 0 && toSpecialCaseCount == 0) {
        validateMsg = 'Password must have one uppercase  & one special character';
      }
      if (toLowerCaseCount == 1 && toUpperCaseCount == 1 && toSpecialCaseCount == 1) {
        validateMsg = '';
      }
    }
    return validateMsg;
  }

  checkAccess(page,type,iscontentType=false,iscontentTypeCheck=false,popupshow=true){
    let user = JSON.parse(localStorage.getItem("user"));
    let domainId = user?.domain_id;
    let accessData = [];
    if(user) {
      let userId = user?.Userid;
      let roleId = user?.roleId;
      let apiData = {
        'apiKey': this.apiKey,
        'userId': userId,
        'domainId': domainId,
        'roleId': roleId,
        'adminPage' : 0
      };
      if(iscontentType) {
        apiData['contentTypeId'] = page
      }

      this.dashboardService.getRolesAndPermissions(apiData).subscribe(roles => {
        let flag: any = '1';
        if(!iscontentType) {
        localStorage.setItem('param',JSON.stringify(roles));
        }
        let rolesData = roles;
        if(rolesData){
          if(iscontentType && !iscontentTypeCheck) {
            accessData = rolesData.items;
          } else if(iscontentType && iscontentTypeCheck && page!=33) {
            let newFiltered = rolesData.items[0].pageAccess.find((item) => item.name == type);
            let permission = newFiltered?.roles?.find((role) => role.id == roleId);
            if(permission?.access == 0 ){
              if(popupshow){this.modalService.open(NoPermissionPopupComponent, {backdrop: 'static', keyboard: false, centered: true});}
              this.checkAccessVal = false;
              localStorage.setItem('checkAccess',flag);  
            } else {
              this.checkAccessVal = true;
              localStorage.setItem('checkAccess',flag);  
            }
          } else {
            let filtered = rolesData.items.find((item) => item.contentTypeId == page);
            if (filtered !== undefined) {
              let newFiltered = filtered?.pageAccess.find((item) => item.name == type);
              let permission = newFiltered?.roles?.find((role) => role.id == roleId);
              if(permission?.access == 0){
                if(popupshow){this.modalService.open(NoPermissionPopupComponent, {backdrop: 'static', keyboard: false, centered: true});}
                this.checkAccessVal = false;
                localStorage.setItem('checkAccess',flag);  
              }
              else{
                this.checkAccessVal = true;
                localStorage.setItem('checkAccess',flag);  
              }
            }
            else{
              this.checkAccessVal = true;
              localStorage.setItem('checkAccess',flag);  
            }
          }
        } else {
          if(!iscontentType)
            this.checkAccessVal = true;
            localStorage.setItem('checkAccess',flag);  
        }
        if(iscontentType && !iscontentTypeCheck) {
          localStorage.setItem('checkAccess',flag); 
          this.checkAccessItems = accessData;
        }
        
      });
    }
  }

  checkDomain() {
    let umUrl = 'under-maintenance';
    let maintanancePopup = localStorage.getItem("maintanancePopup");
    if (maintanancePopup == '0') {
      return true;
    }
    else {
      let domainName = localStorage.getItem("domainName");
      const subDomainData = new FormData();
      subDomainData.append('apiKey', Constant.ApiKey);
      subDomainData.append('domainName', domainName);
      this.validateSubDomain(subDomainData).subscribe((response) => {
        if (response.status == "Success") {
          if (response.maintanancePopup == '1') {
            localStorage.setItem("maintanancePopup", '1');
            setTimeout(() => {
              this.router.navigate([umUrl]);
            }, 500);
          }
          else {
            localStorage.setItem("maintanancePopup", '0');
            return true;
          }
        }
        else {
          localStorage.setItem("maintanancePopup", '0');
          return true;
        }
      });
    }

  }
  generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}
getUpdateUserData()
{
  let dealerCode = localStorage.getItem('dealerCode');
    let newPageData= localStorage.getItem('newPageData');
  if(newPageData && this.userId)
    {
      let webVersionApp: any = '';
      let platformId = localStorage.getItem('platformId');
    
      
if (platformId == '1' || platformId == '3' || platformId == '2') {



switch (platformId) {
  case '1':
    webVersionApp = environment.webVersionCollabtic;
    break;
  case '3':
    webVersionApp = environment.webVersionCBA;
    break;
  case '2':
    if (this.domainId == 52) {
      webVersionApp = environment.webVersionTVS;
    }
    if (this.domainId == 82) {
      webVersionApp = environment.webVersionMAHLE;
    }
    if (this.domainId == 7) {
      webVersionApp = environment.webVersionKIA;
    }
    if (this.domainId == 1 && Constant.acxDomain == '1') {
      webVersionApp = environment.webVersionACX;
    }
    break;
}
}

      let newPageDataArr=JSON.parse(newPageData);
      if(newPageDataArr[0].timeStamp)
        {
   var apiFormData = new FormData();
   apiFormData.append('apiKey', Constant.ApiKey);
   apiFormData.append('domainId', this.domainId);
   apiFormData.append('dealerCode', dealerCode);
   apiFormData.append('userId', this.userId);
   apiFormData.append('itemValues', newPageData);
   apiFormData.append('appVersion', webVersionApp);
   apiFormData.append('platform', '3');
   apiFormData.append('timeStamp', newPageDataArr[0].timeStamp);
   

   this.dashboardService.apiGetactionuseractivity(apiFormData).subscribe((response) => {
   
    // remove user from local storage to log user out
    let lid = localStorage.getItem("languageId");
    let lname = localStorage.getItem("languageName");

    let teamSystem = localStorage.getItem("teamSystem");
    localStorage.removeItem("user");
    if (teamSystem) {
      this.authService.logoutRedirect();
      /*
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
   });
   */
    }

    
  
  
   


    this.userSubject.next(null);

    localStorage.clear();

    // Collabtic setup
    //let platformId = PlatFormType.Collabtic;
    //let PlatFormName = PlatFormNames.Collabtic;

    // Mahle setup
    let platformId = PlatFormType.MahleForum;
   let PlatFormName = PlatFormNames.MahleForum;
    //let PlatFormName = PlatFormNames.Tvs;

    // CBA Forum
    //let platformId = PlatFormType.CbaForum;
    //let PlatFormName = PlatFormNames.CbaForum;

    localStorage.setItem("languageId", lid);
    localStorage.setItem("languageName", lname);
    //localStorage.setItem('newPageData',newPageData);
    localStorage.setItem("platformId", platformId);
    localStorage.setItem("platformName", PlatFormName);

    localStorage.setItem("loggedOut", "1");
    if (teamSystem) {
      this.router.navigate(["auth/integration"]);
    } else {
      localStorage.removeItem("teamSystem");
      let url = '/auth/login';
      let platformId = localStorage.getItem("platformId");
      if(window.location.host==Constant.knowledgeForumHostName)
      {
        url = 'auth/integration';
        //this.router.navigate(["auth/integration"]);
        window.location.href = url;
      }
      else if( window.location.host==Constant.repairifySSoForumHostName  || window.location.host==Constant.repairifyForumHostName)
      {
        url = '/auth/login-type';
        //url='login-index/'+Constant.repairifyForumDomainId;
        //this.router.navigate(["auth/integration"]);
        window.location.href = url;
      }
      else if (window.location.host==Constant.cbatacbetaForumHostName || window.location.host==Constant.cbatacForumHostName) {
        window.location.href = 'sso/index.php?slo';
      }
      else
      {

        window.location.href = url;
      }

      //this.router.navigate(["auth"]);
    }
  });
  }
  }
}
  //logout user
  logout() {

    let platformId2 = localStorage.getItem("platformId");
    if(platformId2=='2' && this.domainId==52)
      {
        this.getUpdateUserData();
      }
      else
      {

    // remove user from local storage to log user out
    let lid = localStorage.getItem("languageId");
    let lname = localStorage.getItem("languageName");

    let teamSystem = localStorage.getItem("teamSystem");
    localStorage.removeItem("user");
    if (teamSystem) {
      this.authService.logoutRedirect();
      /*
      this.authService.logoutPopup({
        mainWindowRedirectUri: "/"
   });
   */
    }

    
  
  
   


    this.userSubject.next(null);

    localStorage.clear();

    // Collabtic setup
    // let platformId = PlatFormType.Collabtic;
    // let PlatFormName = PlatFormNames.Collabtic;

    // Mahle setup
  //let platformId = PlatFormType.MahleForum;
   //let PlatFormName = PlatFormNames.MahleForum;
    //let PlatFormName = PlatFormNames.Tvs;

    // CBA Forum
    let platformId = PlatFormType.CbaForum;
    let PlatFormName = PlatFormNames.CbaForum;

    localStorage.setItem("languageId", lid);
    localStorage.setItem("languageName", lname);

    localStorage.setItem("platformId", platformId);
    localStorage.setItem("platformName", PlatFormName);

    localStorage.setItem("loggedOut", "1");
    if (teamSystem) {
      this.router.navigate(["auth/integration"]);
    } else {
      localStorage.removeItem("teamSystem");
      let url = '/auth/login';
      let platformId = localStorage.getItem("platformId");
      if(window.location.host==Constant.knowledgeForumHostName)
      {
        url = 'auth/integration';
        //this.router.navigate(["auth/integration"]);
        window.location.href = url;
      }
      else if( window.location.host==Constant.repairifySSoForumHostName  || window.location.host==Constant.repairifyForumHostName)
      {
        url = '/auth/login-type';
        //url='login-index/'+Constant.repairifyForumDomainId;
        //this.router.navigate(["auth/integration"]);
        window.location.href = url;
      }
      else if (window.location.host==Constant.cbatacbetaForumHostName || window.location.host==Constant.cbatacForumHostName) {
        window.location.href = 'sso/index.php?slo';
      }
      else
      {

        window.location.href = url;
      }

      //this.router.navigate(["auth"]);
    }
      }
    
   
   
  }

  // validate sub domain
  validateSubDomain(domainData) {
    return this.http.post<any>(this.apiUrl.apivalidateSubDomain(), domainData);
  }

  //validate email
  resetPassword(rpData) {
    return this.http.post<any>(this.apiUrl.apiResetPassword(), rpData);
  }

  //reset password
  changePassword(cpData) {
    return this.http.post<any>(this.apiUrl.apiChangePassword(), cpData);
  }

  // Change password
  changeForcePassword(cpData) {
    return this.http.post<any>(this.apiUrl.apiChangeFPassword(), cpData);
  }

  // Change password
  changeUserPassword(cpData) {
    return this.http.post<any>(this.apiUrl.apiChangeUserPassword(), cpData);
  }

  apiSaveDocumentFolder(cpData) {
    return this.http.post<any>(this.apiUrl.apiSaveDocumentFolder(), cpData);
  }

  apiGetDocumentFolder(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetDocumentFolder(), cpData);
  }

  apiGetDashboardUpdate(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetDashboardUpdate(), cpData);
  }

  getWeeklyDashboard(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetWeeklyDashboard(), cpData);
  }
  
  getDashboardUpdateTechSupport(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetDashboardUpdateTechSupport(), cpData);
  }

  getTechSupportTickets(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetTechSupportTickets(), cpData);
  }

  getTechSupportDailyTickets(data) {
    return this.http.post<any>(this.apiUrl.apiGetTechSupportDailyTickets(), data);
  }

  downloadTechSupportTickets(cpData) {
    return this.http.post<any>(this.apiUrl.apiDownloadTechSupportTickets(), cpData);
  }
    
  getChartUpdate(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetChartUpdate(), cpData);
  }

  getDashboardmetrics(cpData) {
    return this.http.post<any>(this.apiUrl.apiGetDashboardmetrics(), cpData);
  }
  
  apiSaveCategoryFolder(cpData) {
    return this.http.post<any>(this.apiUrl.apiSaveCategoryFolder(), cpData);
  }

  apiSavePartCategoryFolder(cpData) {
    return this.http.post<any>(this.apiUrl.apiSavePartCategoryFolder(), cpData);
  }

  // resent verification email
  resetVerificationEmail(mData) {
    return this.http.post<any>(this.apiUrl.apiResetVerificationEmail(), mData);
  }

  // resent verification email
  resetVerificationEmailV2(mData) {
    return this.http.post<any>(this.apiUrl.apiResetVerificationEmailV2(), mData);
  }

  // user checked verification email
  verifiedEmail(mData) {
    return this.http.post<any>(this.apiUrl.apiVerifiedEmail(), mData);
  }

  // Admin email notification new user signup
  signupAdminNotify(mData) {
    return this.http.post<any>(this.apiUrl.apiSignupAdminNotify(), mData);
  }

  // Change Signup Email
  changeSignupEmail(data) {
    return this.http.post<any>(this.apiUrl.apiChangeSignupEmail(), data);
  }

  // get language list
  getLanguageList(mData) {
    return this.http.post<any>(this.apiUrl.apiGetLangUageList(), mData);
  }

    // get language list
  getactivethreadusers(mData) {
    return this.http.post<any>(this.apiUrl.apiGetactivethreadusers(), mData);
  }

  

  // set language list
  saveUserLanguageOption(mData) {
    return this.http.post<any>(this.apiUrl.apiSaveUserLanguageOption(), mData);
  }
  //
  tvsSSOLogin(mData) {
    return this.http.post<any>(this.apiUrl.apiTVSSSOLogin(), mData);
  }
  //
  tvsSSODealerLogin(mData) {
    return this.http.post<any>(this.apiUrl.apiTVSSSODealerLogin(), mData);
  }
  tvsVerifyotp(mData) {
    return this.http.post<any>(this.apiUrl.apiTVSverifyotp(), mData);
  }  

  tvsSendotp(mData) {
    return this.http.post<any>(this.apiUrl.apiTVSsendotp(), mData);
  } 

  // Get employee Info
  getEmployeeInfoTVSSSO(mData) {
    return this.http.post<any>(this.apiUrl.apiTVSSSOGetEmployeeInfo(), mData);
  }
   // Get dealer Info
   getDealerInfoTVSSSO(mData) {
    return this.http.post<any>(this.apiUrl.apiTVSSSOGetDealerInfo(), mData);
  }

  // user checked verification email
  getPolicyContent(mData) {
    return this.http.post<any>(this.apiUrl.apiGetPolicyContent(), mData);
  }
  newBusinessSignup(newbsignupData) {
    return this.http.post<any>(this.apiUrl.apiNewBusinessSignup(), newbsignupData);
  }
  //
  newBusinessSetup(mData) {
    return this.http.post<any>(this.apiUrl.apiNewBusinessSetup(), mData);
  }
  saveBusinessOptions(mData) {
    return this.http.post<any>(this.apiUrl.apiSaveBusinessOptions(), mData);
  }
  businessInviteNewMembers(mData) {
    return this.http.post<any>(this.apiUrl.apiBusinessInviteNewMembers(), mData);
  }
  decodeEmailaddress(mData) {
    return this.http.post<any>(this.apiUrl.apiDecodeEmailaddress(), mData);
  }
  salesdashboardAPI(mData) {
    return this.http.post<any>(this.apiUrl.apiSalesdashboard(), mData);
  }
  salestype2dashboardAPI(mData) {
    return this.http.post<any>(this.apiUrl.apiSalesType2dashboard(), mData);
  }  
  casesPriorityAPI(mData) {
    return this.http.post<any>(this.apiUrl.apiCasesPriority(), mData);
  }  
  caseCustomerPriorites(mData) {
    return this.http.post<any>(this.apiUrl.apiCaseCustomerPriorites(), mData);
  }  
  salesdashAttributeAPI(mData) {
    return this.http.post<any>(this.apiUrl.apiSalesdashAttribute(), mData);
  }

 getSalesProfit(mData) {
    return this.http.post<any>(this.apiUrl.apiGetSalesProfit(), mData);
  }

  getprofithome(mData) {
    return this.http.post<any>(this.apiUrl.apiGetprofithome(), mData);
  }
  
  getprofithomedata(mData) {
    return this.http.post<any>(this.apiUrl.apiGetprofithomedata(), mData);
  }

 getprofitsalesrecapdata(mData) {
    return this.http.post<any>(this.apiUrl.apiGetprofitsalesrecapdata(), mData);
  }  

  upateSalesProfit(mData) {
    return this.http.post<any>(this.apiUrl.apiUpdateSalesProfit(), mData);
  }

  saveprofilehomemonthdata(mData) {
    return this.http.post<any>(this.apiUrl.apiSaveprofilehomemonthdata(), mData);
  }

  apiGetUserMetrics(paramsData) {
    return this.http.get<any>(this.apiUrl.apiGetUserMetrics(), {params: paramsData});
  }

  apiGetTechInfoMetrics(paramsData) {
    return this.http.post<any>(this.apiUrl.apiGetTechInfoMetrics(), paramsData);
  }  

  getHqDomainId(){
    let platformId = localStorage.getItem("platformId");
    if(platformId=='3')
    {
     return 1;
    }
    else
    {
      let user = JSON.parse(localStorage.getItem("user"));
      let domainId = user?.domain_id;
      return domainId;
    }
  
  }
}
